import { useNavigate } from "react-router-dom";
import { ArrowRight, UserRound } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { EmailCodeSignIn } from "../auth/EmailCode";

export default function CreateProfile() {
  const { user, checkAuth } = useAuth();
  const navigate = useNavigate();
  if (user) return (
    <div className="mt-5 rounded-xl bg-brand-soft/60 border border-brand/20 p-4" data-testid="create-profile-signed-in">
      <div className="flex items-center gap-2 font-semibold text-ink"><UserRound className="w-4 h-4 text-brand" aria-hidden="true" /> You're already signed in</div>
      <p className="text-sm text-body mt-1">Add your details and build a CV from scratch in your profile.</p>
      <button data-testid="create-profile-open" onClick={() => navigate("/dashboard/profile")} className="mt-3 gi-btn gi-btn-primary gi-btn-sm">
        Open my profile <ArrowRight className="w-4 h-4" aria-hidden="true" />
      </button>
    </div>
  );
  return (
    <div className="mt-5" data-testid="create-profile">
      <EmailCodeSignIn withStatus testid="create-profile" cta="Verify and create my profile"
        onDone={async () => { await checkAuth(); navigate("/dashboard/profile?new=1"); }} />
      <p className="mt-3 text-xs text-faint">
        By continuing you agree to our <a href="/terms" className="text-brand hover:underline">Terms</a> and <a href="/privacy" className="text-brand hover:underline">Privacy Policy</a>.
      </p>
    </div>
  );
}
